export default "__VITE_ASSET__JmIF_3W$__"